export default {
  icon: ' mdi-sitemap',
  text: 'Categoria',
  permissions: [
    { name: 'categoriesIndex', text: 'Visualizar Categorias', value: 0 },
    { name: 'categoryCreateEdit', text: 'Cadastrar/Editar Categoria', value: 0 },
  ]
}